import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box, Container, Paper, TextField, Button, Typography, Alert, CircularProgress,
} from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import apiService from '../services/api';

const ForceChangePassword: React.FC = () => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { clearMustChangePassword } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (newPassword.length < 8) { setError('New password must be at least 8 characters.'); return; }
    if (newPassword !== confirmPassword) { setError('New passwords do not match.'); return; }
    if (newPassword === currentPassword) { setError('New password must be different from your current password.'); return; }
    setLoading(true);
    setError('');
    try {
      await apiService.forceChangePassword(currentPassword, newPassword);
      clearMustChangePassword();
      navigate('/');
    } catch (err: any) {
      setError(err.response?.data?.message || 'Failed to change password. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box sx={{ marginTop: 8, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Paper elevation={3} sx={{ padding: 4, width: '100%' }}>
          <Typography component="h1" variant="h5" align="center" gutterBottom fontWeight={600}>
            Set New Password
          </Typography>
          <Typography variant="body2" align="center" color="text.secondary" sx={{ mb: 2 }}>
            You must set a new password before continuing.
          </Typography>

          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

          <Box component="form" onSubmit={handleSubmit}>
            <TextField
              margin="normal" required fullWidth
              label="Current Password" type="password"
              value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)}
              disabled={loading}
            />
            <TextField
              margin="normal" required fullWidth
              label="New Password" type="password"
              value={newPassword} onChange={(e) => setNewPassword(e.target.value)}
              disabled={loading} helperText="Minimum 8 characters"
            />
            <TextField
              margin="normal" required fullWidth
              label="Confirm New Password" type="password"
              value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)}
              disabled={loading}
            />
            <Button
              type="submit" fullWidth variant="contained"
              sx={{ mt: 3 }} disabled={loading || !currentPassword || !newPassword || !confirmPassword}
            >
              {loading ? <CircularProgress size={24} color="inherit" /> : 'Update Password'}
            </Button>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default ForceChangePassword;
